import React from "react";
import { FlightCardBadges } from "../../FlightCard/components/FlightCardBadges.js";
import { FlightCardBadge } from "../../FlightCard/components/FlightCardBadge.js";
import { getCampaignBadgesConfig } from "../../../../utils/flightCampaignConfig.js";
import { getFlightDetailsFetchStatus } from "../../../../store/flightDetails/selectors.js";
import { useSelector } from "react-redux";
import { SkeletonLoader } from "@bookingcom/bui-react";
export function FlightDetailsCampaignBadgeSection({ campaignBadges, showLoader }) {
    const badges = getCampaignBadgesConfig(campaignBadges);
    const fetchStatus = useSelector(getFlightDetailsFetchStatus);
    if (showLoader && fetchStatus === "loading")
        return React.createElement(SkeletonLoader, { width: "140px" });
    if (!badges.length)
        return null;
    return (React.createElement(FlightCardBadges, null, badges.map((badge, idx) => (React.createElement(FlightCardBadge, { key: `keyCampaignBadge-${idx}`, alternative: false, isInteractive: false, ...badge })))));
}
